import { FC } from 'react';
import { FormInstance, Input } from 'antd';
import slug from 'slug';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { PlatformForm as Form } from '@/shared/components/forms';

import { OAuthApplicationFormValues } from '../../../../../../types';
import OAuthApplicationIconField from '../OAuthApplicationIconField';

interface ApplicationMetadataSectionProps {
    form: FormInstance<OAuthApplicationFormValues>;
}

const ApplicationMetadataSection: FC<ApplicationMetadataSectionProps> = ({ form }) => {
    const { token } = useAntDesignTheme();
    return (
        <>
            <OAuthApplicationIconField form={form} />
            <Form.Item
                label='Application Name'
                name='name'
                rules={[
                    { required: true, message: 'Application name is required' },
                    { min: 3, message: 'Use at least 3 characters' },
                    { max: 50, message: 'Use no more than 50 characters' },
                ]}
            >
                <Input
                    id='oauth-application-field-name'
                    placeholder='Acme Research...'
                    onChange={(event) => form.setFieldValue('slug', slug(event.target.value))}
                />
            </Form.Item>
            <Form.Item
                label='Application Slug'
                name='slug'
                rules={[
                    { required: true, message: 'Application slug is required' },
                    { pattern: /^[a-z0-9-]+$/, message: 'Use lowercase letters, numbers, and dashes only' },
                ]}
            >
                <Input id='oauth-application-field-slug' placeholder='acme-research...' />
            </Form.Item>
            <Form.Item
                label='Short Description'
                name='shortDescription'
                rules={[
                    { required: true, message: 'A short description is required' },
                    { max: 120, message: 'Use no more than 120 characters' },
                ]}
            >
                <Input
                    id='oauth-application-field-short-description'
                    showCount
                    maxLength={120}
                    placeholder='Connect Acme Research To Your Workspace...'
                />
            </Form.Item>
        </>
    );
};

export default ApplicationMetadataSection;
